import type { ClientOverviewRepository } from "../repositories/ClientOverviewRepository";
import type { RevenueThisMonthInsightsEntity } from "../entities/RevenueThisMonthInsightsEntity";

export class GetRevenueThisMonthInsightsUseCase {
  constructor(private repository: ClientOverviewRepository) {}

  async execute(): Promise<RevenueThisMonthInsightsEntity> {
    return this.repository.getRevenueThisMonthInsights();
  }
}

